var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDogCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.1 27",
    style: {
      enableBackground: "new 0 0 69.1 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C10000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    className: "st0",
    d: "M53.8,14.8c0.1-0.2-2.5-0.6-4.2-0.9l2.1-2c0.6-0.5,0.6-1.4,0.2-2l-4.2-6.2 C47.4,3.2,47,3,46.5,2.9l-2.4-0.2c-0.9-0.1-1.6,0.5-1.7,1.4c-0.1,0.7,0.3,1.3,0.9,1.6l2.7,0.4c1.2,0.2,2.1,1.3,2,2.6l-0.5,4.7 L46.7,13l0.5-4.4c0.1-0.8-0.5-1.6-1.3-1.7l-6.6-1c-0.3,0-0.6,0-0.9,0.1L37,6.5c-0.8,0.3-1.2,1.3-0.8,2.1c0.3,0.8,1.3,1.2,2.1,0.8 l0.9-0.4l4.7,0.7l-0.2,1.4l-0.1,1c-1.3-0.2-2.7-0.3-4-0.4c-7.3-0.3-10.3,2.9-13.7,3.5c-0.2-0.4-0.7-0.8-1.2-0.9L22,13.7l-0.3-3.4 l-0.3-2.9l4.8-1.2c0.5-0.1,1-0.5,1.2-1l1.2-2.4c0.5-0.9,0.2-2.1-0.7-2.6S25.8,0,25.3,0.9c0,0.1-0.1,0.1-0.1,0.2l-0.8,1.6l-5.6,1.4 c-0.9,0.2-1.5,1.1-1.4,2l0.5,4.4c0,0,0,0.1-0.1,0.1l-1,1.7l-0.4-0.1l-2.8-0.7l0.5-5C14.2,6,14,5.5,13.6,5.1l-1.9-2 c-0.7-0.8-1.9-0.9-2.7-0.2C8.3,3.6,8.2,4.8,8.8,5.6c0,0.1,0.1,0.1,0.2,0.2l1.3,1.3l-0.6,5.7c-0.1,0.9,0.5,1.8,1.4,2l3.8,1 l-0.3,0.6c-0.2,0.4-0.3,0.9-0.2,1.3c0,0.1,0,0.2,0.1,0.3c0.3,0.9,0.7,1.8,1.1,2.7c0.1,0.3,0.2,0.6,0.3,0.9 c-2.5,0.1-5.3,0.4-6.6,0.5C7.1,22.4-1.3,24,0.2,26s4.9,0.6,9.5,0.5c3-0.1,7.1-0.1,10.1-1.4c1.1,0.5,2.3,0.7,3.5,0.7 c0.4,0,0.9,0,1.3-0.1c9.6,1.2,24.9-0.1,24.9-0.1l3.9-0.7c0.5,0.1,1,0.1,1.5,0C54.9,24.8,52.6,17.2,53.8,14.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    className: "st0",
    d: "M65.4,22.6c0.8,0.4,2,0.9,3,1.4c1.5,0.8,0.2,1.3,0.2,1.3l-1.7,0.2c0,0.3,0.1,0.7,0.1,1.1 l-11.2-3.1c-0.7-3.1-1.4-7.5-0.2-8.7c3.1-3.4,4.2-3.6,5.1-2.8C61.7,13,64,18.9,65.4,22.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDogCollapse);
export default __webpack_public_path__ + "static/media/icon-dog-collapse.1261833264abedaf83c4897db2bfd179.svg";
export { ForwardRef as ReactComponent };